import React from "react";
import classname from "classnames";
import { userHasAdminRole, userHasOneOfRoles } from "utils/helpers/functions";
import { useSelector } from "react-redux";
import { LoginSelector } from "store/auth/login/selectors";
import arrow from "assets/images/svg/arrow-white.svg";
import NGITooltip from "components/Common/utils/NGITooltip";
import classnames from "classnames";

const CustomButton = ({
  text,
  roles,
  hideRoles,
  icon,
  iconImg,
  size,
  color,
  type,
  textColor = "#000",
  toolTipText = "",
  disabled,
  className = "",
  containerClassName = "",
  isDropdown = false,
  isButtonRound = false,
  ...props
}) => {
  const { user } = useSelector(LoginSelector);

  if (!userHasAdminRole(user)) {
    if (userHasOneOfRoles(hideRoles, user)) {
      return null;
    }
    if (roles && !userHasOneOfRoles(roles, user)) {
      return null;
    }
  }

  return (
    <div className={classnames(containerClassName, "button-container")}>
      <NGITooltip title={toolTipText || text}>
        <button
          {...props}
          disabled={!!disabled}
          className={classname(
            "button-general",
            className,
            size === "small" && "button-small",
            size === "lite" && "button-lite",
            type === "round" && "button-round",
            type === "success" && "button-success",
            type === "error" && "button-error",
            color === "outlined" && "button-outlined",
            color === "outlined-white" && "button-outlined-white",
            color === "outlined-error" && "button-outlined-error",
            disabled && "button-disabled",
            isDropdown && "button-dropdown",
            isButtonRound && "round-button"
          )}
        >
          {!!iconImg && <img className="image-icon-btn" src={iconImg} alt="button-image" />}
          {!!icon && <span className="button-icon">{icon}</span>}
          {text}
          {isDropdown && (
            <div className="dropdown-img-container">
              <img className="dropdown-img" src={arrow} alt="button-image" />
            </div>
          )}
        </button>
      </NGITooltip>
    </div>
  );
};
export default CustomButton;
